import React, { Component } from "react";
import { BrowserRouter, RouteProps } from "react-router-dom";

import { RouterMap } from "./routers-map";
import { IStorageManagerProps, StorageManager } from "./storage-manager";

interface MainAppsProps extends IStorageManagerProps {
  dataRouteMap?: RouteProps[];
}

interface MainAppsState {}

export class MainApps extends Component<MainAppsProps, MainAppsState> {
  static defaultProps = {};

  render() {
    const { dataRouteMap = [] } = this.props;
    const { children, ...props } = this.props;

    return (
      <StorageManager {...props}>
        {children}
        <BrowserRouter>
          <RouterMap renderRoute={dataRouteMap} />
        </BrowserRouter>
      </StorageManager>
    );
  }
}
